import {
  FETCH_SPRINT_DATA,
  FETCH_SPRINT_DATA_SUCCESS,
  FETCH_SPRINT_DATA_ERROR,
  SAVE_SPRINT,
  SAVE_SPRINT_SUCCESS,
  SAVE_SPRINT_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: null,
  loading: false,
  saving: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case FETCH_SPRINT_DATA:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    break;
    case FETCH_SPRINT_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    break;
    case FETCH_SPRINT_DATA_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
    break;
    case SAVE_SPRINT:
      return {
        ...state,
        data: action.payload,
        saving: true,
        error: null,
      }
    break;
    case SAVE_SPRINT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        saving: false,
        error: null,
      }
    break;
    case SAVE_SPRINT_ERROR:
      return {
        ...state,
        saving: false,
        error: action.payload,
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/sprintReducer.js